// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { NativeCallDetails } from "@lib/api/website/v3/NativeCallDetails";

export interface IWebsiteApi
{
  makeNativeCall(method: string, args: any[], details: NativeCallDetails): Promise<any>;
};